import React from "react";
import "./App.scss";
import SimplisticPage from "./views/SimplisticPage";

function App() {
  return <SimplisticPage />;
}

export default App;
